import type { FC } from "react";
import { memo, useCallback } from "react";
import { WithStyle } from "utils/WithStyle";
import Text from "../../../Text";
import * as Styled from "./Option.styled";
import { OptionProps } from "./types";

const Component: FC<OptionProps> = memo((props) => {
    const { value, label, onClick } = props;

    const handleOnClick = useCallback(
        (event: React.MouseEvent<HTMLLIElement>) => {
            event.stopPropagation();
            onClick && onClick({ value, label });
        },
        [onClick, value, label]
    );

    return (
        <Styled.Option onClick={handleOnClick}>
            <Text variant="label">{label}</Text>
        </Styled.Option>
    );
});

Component.displayName = "Option";

export const Option: FC<OptionProps> & WithStyle = Object.assign(Component, {
    Style: Styled.Option,
});
